<section class="company-integrations">
    <!-- Verbunden -->
    <ng-container *ngIf="connectedVendors.length > 0">
        <h3 class="company-integrations__section-title">
            {{ 'aumico_company_integrations_section_connected' | i18next }}
        </h3>
        <div class="company-integrations__grid">
            <aumico-vendor-integration-card
                *ngFor="let vendor of connectedVendors; trackBy: trackByVendor"
                [vendor]="vendor"
                [connected]="(vendorStates[vendor.vendor] | async)?.connected ?? true"
                [needsAction]="(vendorStates[vendor.vendor] | async)?.needsAction ?? false"
                (infoClick)="onInfo(vendor)"
            ></aumico-vendor-integration-card>
        </div>
    </ng-container>

    <!-- Verfügbar -->
    <ng-container *ngIf="availableVendors.length > 0">
        <h3 class="company-integrations__section-title">
            {{ 'aumico_companies_integrations_section_available' | i18next }}
        </h3>
        <div class="company-integrations__grid">
            <aumico-vendor-integration-card
                *ngFor="let vendor of availableVendors; trackBy: trackByVendor"
                [vendor]="vendor"
                [connected]="false"
                [needsAction]="false"
                (infoClick)="onInfo(vendor)"
            ></aumico-vendor-integration-card>
        </div>
    </ng-container>
</section>

<!-- Info modal: per-org vendor on the company page redirects to Org Settings. -->
<aumico-integration-go-to-admin-modal
    *ngIf="activeInfoVendor != null"
    [vendor]="activeInfoVendor"
    [mapping]="activeMapping"
    [connection]="activeConnection$ | async"
    [isAdmin]="isAdmin"
    (goToAdmin)="onGoToAdmin()"
    (closed)="onModalClosed()"
></aumico-integration-go-to-admin-modal>
